import { render } from "./additional-info-box.component.vue?vue&type=template&id=415e7a8f&ts=true"
import script from "./additional-info-box.component.vue?vue&type=script&lang=ts"
export * from "./additional-info-box.component.vue?vue&type=script&lang=ts"

import "./additional-info-box.component.vue?vue&type=style&index=0&id=415e7a8f&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__